module.exports = __webpack_public_path__ + "static/Libryo-7babdf9f2231efc24c6bb6dba023de01.jpg";